import { useState, useEffect } from 'react';
import { CurrencyValue } from '../../../common/currencyValue';

const YearlyTenantPdfRow = ({ apt }) => {
    const [renter, setRenter] = useState();
    const [owner, setOwner] = useState();

    useEffect(() => {
        apt?.tenants?.map(({ tenant, details }) => {
            const { isActive, isPrimary, tenantType } = tenant;
            const { name, phone, email } = details;
            if (isActive && isPrimary) {
                if (tenantType === 'renter') {
                    setRenter({
                        name,
                        phone,
                        email 
                    })
                } else if (tenantType === 'owner') {
                    setOwner({
                        name,
                        phone,
                        email 
                    })
                }
            }
            return ''
        });
    }, [apt]);

    return (
        <div className='pdf-row'>
            <div className='yearly-apt'>{apt?.apartmentNum}</div>
            <div className='yearly-apt'>{renter?.name}</div>
            <div className='yearly-apt'>{renter?.phone}</div>
            <div className='yearly-apt'>{renter?.email}</div>
            <div className='yearly-apt'>{owner?.name}</div>
            <div className='yearly-apt'>{owner?.phone}</div>
            <div className='yearly-apt'>{owner?.email}</div>
            <div className='yearly-apt'><CurrencyValue currency={apt?.currency}>{apt?.monthlyFee}</CurrencyValue></div>
        </div>        
    )
}

export default YearlyTenantPdfRow;